import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { LocalesEnum } from '~core/modules/l10n/constants/locales.enum';

@Pipe({
  name: 'dateRangeView'
})
export class DateRangeViewPipe implements PipeTransform {
  datePipe: DatePipe;
  private readonly fullDateFormat = 'd MMMM, yyyy';

  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.datePipe = new DatePipe(locale || LocalesEnum.de);
  }

  private getSameDayView(date: string) {
    return this.datePipe.transform(date, this.fullDateFormat);
  }

  private getSameMonthView(startDate: string, endDate: string) {
    const dayFormat = 'd';
    const startDay = this.datePipe.transform(startDate, dayFormat);
    const endDay = this.datePipe.transform(endDate, dayFormat);
    const monthAndYearView = this.datePipe.transform(startDate, 'MMMM, yyyy');

    return `${startDay} - ${endDay} ${monthAndYearView}`;
  }

  private getDifferentYearView(startDate: string, endDate: string) {
    const startView = this.datePipe.transform(startDate, this.fullDateFormat);
    const endView = this.datePipe.transform(endDate, this.fullDateFormat);

    return `${startView} - ${endView}`;
  }

  private getSameYearAndDifferentMonthView(startDate: string, endDate: string) {
    const rangeFormat = 'd MMMM';
    const startView = this.datePipe.transform(startDate, rangeFormat);
    const endView = this.datePipe.transform(endDate, rangeFormat);
    const sameYear = this.datePipe.transform(startDate, 'yyyy');
    return `${startView} - ${endView}, ${sameYear}`;
  }

  transform(startDate: string, endDate: string): string {
    const startDay = new Date(startDate).getDate();
    const startMonth = new Date(startDate).getMonth();
    const startYear = new Date(startDate).getFullYear();
    const endDay = new Date(endDate).getDate();
    const endMonth = new Date(endDate).getMonth();
    const endYear = new Date(endDate).getFullYear();

    const isSameDay = (startDay === endDay) && (startMonth === endMonth) && (startYear === endYear);
    const isSameMonth = (startMonth === endMonth) && (startYear === endYear);
    const isSameYear = startYear === endYear;

    if (!startDate || !endDate) {
      return '';
    }

    if (isSameDay) {
      return this.getSameDayView(startDate);
    }

    if (isSameMonth) {
      return this.getSameMonthView(startDate, endDate);
    }

    if (!isSameYear) {
      return this.getDifferentYearView(startDate, endDate);
    }

    if (isSameYear && !isSameMonth) {
      return this.getSameYearAndDifferentMonthView(startDate, endDate);
    }

    return '';
  }
}
